import React, { useState } from 'react'
import { useCopyToClipboard } from '../../hooks';
import Button from '../Elements/Button';
import './Copy.scss';

const Copy = ({text, title, onCopied, showTooltip}) => {
    //eslint-disable-next-line
    const [copied, copy] = useCopyToClipboard(text);
    const [isCopiedTooltip, setIsCopiedTooltip] = useState();

    const onCopy = () => {
        copy();
        if(showTooltip) setIsCopiedTooltip(true);
        if(onCopied) onCopied();
    }

    return (
        <div className="copy-component">
            {isCopiedTooltip && <span onClick={() => setIsCopiedTooltip(false)} className="copy-component__tooltip">Copied to clipboard</span>}
            <Button className="button copy-component__btn" onClick={onCopy}>
                <img src={require('../../images/icons/copy.svg').default} alt="copy" />
                <span>{title}</span>
            </Button>
        </div>
    )
}

export default Copy;